import i18n from '../../i18n';
import {
  PUSH_DIGIDIARY_VIEW,
  POP_DIGIDIARY_VIEW,
  RESET_DIGIDIARY_VIEW,
  SET_ACTIVE_FOOTER,
  SHOW_HIDE_FOOTER,
  SHOW_HIDE_HEADER,
  SET_CROP_VIEW_MODE,
  SET_EQUIPMENT_VIEW_MODE,
  DD_SET_MY_FARM_DATA_LOADING,
  SET_SELECTED_CROP_ID,
  SET_SELECTED_EQUIPMENT_ID,
} from '../actions';

const initialState = {
  digiDiaryViewArray: [],
  footerTab: i18n.t('DIGI_DIARY'),
  showFooter: true,
  showHeader: false,
  cropDetailsMode: '',
  equipmentDetailsMode: '',
  myFarmLoading: false,
  selectedCropId: '',
  selectedEquipmentId: '',
};

const pushDigiDiaryView = (state, {newView}) => {
  let newArr;
  if (
    state.digiDiaryViewArray[state.digiDiaryViewArray.length - 1] == newView
  ) {
    newArr = [...state.digiDiaryViewArray];
  } else {
    newArr = [...state.digiDiaryViewArray, newView];
  }
  return {
    ...state,
    digiDiaryViewArray: newArr,
  };
};
const popDigiDiaryView = (state) => {
  return {
    ...state,
    digiDiaryViewArray: [
      ...state.digiDiaryViewArray.filter(
        (_, i) => i !== state.digiDiaryViewArray.length - 1
      ),
    ],
  };
};
const resetDigiDiaryView = (state) => {
  return {
    ...state,
    digiDiaryViewArray: [],
  };
};

const footerChange = (state, action) => {
  return {
    ...state,
    footerTab: action.data,
  };
};

const showHideFooter = (state, action) => {
  return {
    ...state,
    showFooter: action.data,
  };
};

const showHideHeader = (state, action) => {
  return {
    ...state,
    showHeader: action.data,
  };
};

const setCropViewMode = (state, action) => {
  return {
    ...state,
    cropDetailsMode: action.data,
  };
};

const setEquipmentViewMode = (state, {data}) => {
  return {
    ...state,
    equipmentDetailsMode: data,
  };
};

const setMyFarmLoading = (state, {myFarmLoading}) => {
  return {
    ...state,
    myFarmLoading: myFarmLoading,
  };
};

const setSelectedCropId = (state, {data}) => {
  return {
    ...state,
    selectedCropId: data,
  };
};

const setSelectedEquipmentId = (state, {data}) => {
  return {
    ...state,
    selectedEquipmentId: data,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PUSH_DIGIDIARY_VIEW:
      return pushDigiDiaryView(state, action);
    case POP_DIGIDIARY_VIEW:
      return popDigiDiaryView(state);
    case RESET_DIGIDIARY_VIEW:
      return resetDigiDiaryView();
    case SET_ACTIVE_FOOTER:
      return footerChange(state, action);
    case SHOW_HIDE_FOOTER:
      return showHideFooter(state, action);
    case SHOW_HIDE_HEADER:
      return showHideHeader(state, action);
    case SET_CROP_VIEW_MODE:
      return setCropViewMode(state, action);
    case SET_EQUIPMENT_VIEW_MODE:
      return setEquipmentViewMode(state, action);
    case DD_SET_MY_FARM_DATA_LOADING:
      return setMyFarmLoading(state, action);
    case SET_SELECTED_CROP_ID:
      return setSelectedCropId(state, action);
    case SET_SELECTED_EQUIPMENT_ID:
      return setSelectedEquipmentId(state, action);
    default:
      return state;
  }
};

export default reducer;
